import { render, staticRenderFns } from "./SortUpdateModal.vue?vue&type=template&id=c12d74e4&scoped=true"
import script from "./SortUpdateModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./SortUpdateModal.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SortUpdateModal.vue?vue&type=style&index=0&id=c12d74e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12d74e4",
  null
  
)

export default component.exports